import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/base/ScrollToTop';
import { comics } from '@/mocks/comics';

const siteUrl = 'https://tianbaolaowu.cn';

function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

const articleContents: Record<string, string> = {
  '1': `<h3>第一章：命运的转折</h3><p>E级猎人成振宇，被同行戏称为"人类最弱兵器"。在这个充满猎人与魔兽的世界里，他是最底层的存在。然而，一切都在那个双重地下城任务中发生了改变。</p><p>当小队遭遇远超预期的怪物群时，振宇选择了牺牲自己，让队友们先逃出去。在濒死之际，一道神秘的声音在他脑海中响起：<strong>"玩家已满足条件，系统激活。"</strong></p><p>他获得了一个类似游戏界面的神秘系统，可以通过完成任务来提升等级和属性。从此，这个曾经最弱的E级猎人，开始了向着最强猎人的蜕变之路。</p><h3>第二章：系统的力量</h3><p>振宇发现这个系统不仅能够让他像游戏角色一样升级，还赋予了他一个独特的能力——"暗影君王"，可以将自己击败的敌人转化为暗影士兵。这意味着他不再是一个人在战斗，而是拥有一支不断壮大的暗影军团。</p><p>随着实力的提升，他逐渐揭开了"门"和"猎人"背后隐藏的真相。原来，这个世界的规则远比他想象的要复杂得多……</p>`,
  '2': `<h3>第一章：化妆的力量</h3><p>任朱静从小就因为长相问题遭受校园霸凌。高中第一天，她做了一个大胆的决定——用自己从网上学来的化妆技术彻底改变自己。</p><p>当镜子中出现一个完全不同的自己时，她几乎不敢相信。从一个被嘲笑的丑小鸭，变成了让所有人都惊艳的校园女神。</p><h3>第二章：两个世界的相遇</h3><p>转学后的朱静遇到了两个男生：全校第一的李修豪和阳光开朗的韩书俊。一个是冷若冰霜的学霸，一个是温暖如春的校草。两人都对她产生了特殊的感情。</p><p>然而，朱静最大的恐惧是——如果有一天，他们看到了卸妆后的自己，一切会变成什么样？</p>`,
  '3': `<h3>第一章：陨落的剑尊</h3><p>天下第一剑尊白御真，在与魔教教主血战的最后一刻，两人同归于尽。这是世人皆知的结局。然而白御真睁开眼睛时，他看到的却是自己二十年前的模样。</p><p><strong>"我……重生了？"</strong></p><p>带着前世所有的记忆和武学，他决定彻底改变命运。那些前世背叛他的人、毁灭他的势力，这一次他要一一清算。</p><h3>第二章：少年剑尊</h3><p>以一个少年的身份重新开始，白御真发现自己虽然失去了巅峰时期的功力，但对武学的理解和经验却全部保留。他可以利用这些，以最快的速度重回巅峰——甚至超越前世。</p>`,
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const comic = comics.find((c) => c.id === id);

  if (!comic) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-10">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
            <i className="ri-emotion-sad-line text-6xl text-foreground-300"></i>
            <h1 className="mt-4 text-2xl font-heading font-bold text-foreground-950">漫画未找到</h1>
            <p className="mt-2 text-foreground-500">抱歉，您要查看的漫画不存在或已被移除。</p>
            <Link to="/" className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const viewsText = comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views.toString();
  const content = articleContents[comic.id] || `<h3>${comic.title}</h3><p>${comic.description}</p>`;
  const categoryObj = { name: comic.category === 'love' ? '恋爱' : comic.category === 'fantasy' ? '奇幻' : comic.category === 'action' ? '动作' : comic.category === 'mystery' ? '悬疑' : comic.category === 'comedy' ? '搞笑' : comic.category === 'horror' ? '恐怖' : comic.category === 'bl' ? '耽美' : '剧情', slug: comic.category };

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: `${categoryObj.name}漫画`, href: `/category/${categoryObj.slug}` },
    { label: comic.title },
  ];

  const breadcrumbSchemaItems = [
    { name: '首页', url: siteUrl },
    { name: `${categoryObj.name}漫画`, url: `${siteUrl}/category/${categoryObj.slug}` },
    { name: comic.title, url: `${siteUrl}/article/${comic.id}` },
  ];

  const seoData = {
    title: `${comic.title}_${comic.author}_韩漫漫画网`,
    description: `${comic.title}是由${comic.author}创作的韩国漫画。${comic.description.substring(0, 100)}。评分${comic.rating}，共${comic.chapters}话，在线免费阅读。`,
    keywords: `${comic.title},${comic.author},韩国漫画,韩漫,${comic.tags.join(',')},免费阅读`,
    canonical: `${siteUrl}/article/${comic.id}`,
    ogType: 'article',
    ogImage: comic.coverImage,
    schema: [
      {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: comic.title,
        description: comic.description,
        author: { '@type': 'Person', name: comic.author },
        image: comic.coverImage,
        datePublished: '2024-01-01',
        dateModified: comic.updateDate,
        publisher: { '@type': 'Organization', name: '韩漫漫画网' },
      },
      getBreadcrumbSchema(breadcrumbSchemaItems),
    ],
  };

  return (
    <>
      <SEOHead data={seoData} />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 pb-14">
          <article className="max-w-4xl mx-auto px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />

            {/* Article Header */}
            <header className="mb-8">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                {comic.title}
              </h1>
              <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-600">
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-user-line"></i>
                  {comic.author}
                </span>
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-star-fill text-accent-400"></i>
                  {comic.rating}
                </span>
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-eye-line"></i>
                  {viewsText} 次阅读
                </span>
                <span className="whitespace-nowrap">{comic.chapters}话</span>
                <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                  comic.status === 'ongoing' ? 'bg-secondary-100 text-secondary-700' : 'bg-background-200 text-foreground-600'
                }`}>
                  {comic.status === 'ongoing' ? '连载中' : '已完结'}
                </span>
              </div>
              <div className="flex flex-wrap gap-1.5 mt-3">
                {comic.tags.map((tag) => (
                  <span key={tag} className="px-2.5 py-1 rounded-full text-xs bg-background-100 text-foreground-600 whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>
            </header>

            {/* Cover Image & Info */}
            <div className="flex flex-col md:flex-row gap-8 mb-10">
              <div className="w-full md:w-60 flex-shrink-0">
                <div className="aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={comic.coverImage}
                    alt={`${comic.title} 漫画封面`}
                    title={`${comic.title} - ${comic.author}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <Link
                  to={`/category/${comic.category}`}
                  className="mt-3 inline-flex items-center justify-center gap-2 w-full px-4 py-2.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  开始阅读
                  <i className="ri-book-open-line"></i>
                </Link>
              </div>

              <div className="flex-1">
                <div className="prose prose-sm max-w-none">
                  <p className="text-foreground-700 leading-relaxed text-base">
                    {comic.description}
                  </p>
                </div>

                {/* Quick Info */}
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-6 p-5 rounded-lg bg-background-100">
                  <div>
                    <span className="text-xs text-foreground-500">作者</span>
                    <p className="text-sm font-medium text-foreground-900 mt-0.5">{comic.author}</p>
                  </div>
                  <div>
                    <span className="text-xs text-foreground-500">状态</span>
                    <p className="text-sm font-medium text-foreground-900 mt-0.5">{comic.status === 'ongoing' ? '连载中' : '已完结'}</p>
                  </div>
                  <div>
                    <span className="text-xs text-foreground-500">总话数</span>
                    <p className="text-sm font-medium text-foreground-900 mt-0.5">{comic.chapters}话</p>
                  </div>
                  <div>
                    <span className="text-xs text-foreground-500">评分</span>
                    <p className="text-sm font-medium text-foreground-900 mt-0.5">{comic.rating}</p>
                  </div>
                  <div>
                    <span className="text-xs text-foreground-500">阅读量</span>
                    <p className="text-sm font-medium text-foreground-900 mt-0.5">{viewsText}</p>
                  </div>
                  <div>
                    <span className="text-xs text-foreground-500">最后更新</span>
                    <p className="text-sm font-medium text-foreground-900 mt-0.5">{comic.updateDate}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Article Content */}
            <section className="border-t border-background-200 pt-8">
              <div
                className="prose max-w-none text-foreground-800 leading-relaxed"
                dangerouslySetInnerHTML={{
                  __html: content
                    .replace(/<h3>/g, '<h3 class="text-xl font-heading font-bold text-foreground-950 mt-8 mb-4" style="font-family: var(--font-heading)">')
                    .replace(/<p>/g, '<p class="mb-4 text-base leading-relaxed">')
                    .replace(/<strong>/g, '<strong class="text-primary-700">'),
                }}
              />
            </section>

            {/* Related Comics */}
            <section className="border-t border-background-200 mt-10 pt-8">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-5" style={{ fontFamily: 'var(--font-heading)' }}>
                相关推荐
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                {comics
                  .filter((c) => c.id !== comic.id && c.category === comic.category)
                  .slice(0, 4)
                  .map((related) => (
                    <Link
                      key={related.id}
                      to={`/article/${related.id}`}
                      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                    >
                      <div className="aspect-[3/4] overflow-hidden bg-background-200">
                        <img
                          src={related.coverImage}
                          alt={related.title}
                          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                      <div className="p-3">
                        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 whitespace-nowrap overflow-hidden text-ellipsis">
                          {related.title}
                        </h3>
                        <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{related.author}</p>
                      </div>
                    </Link>
                  ))}
              </div>
            </section>
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
}